import {
  EDIT_TRANSLATIONS_FAILURE,
  EDIT_TRANSLATIONS_REQUEST,
  EDIT_TRANSLATIONS_SUCCESS,
  CLEAR_PRESERVED_IMPC,
} from './types/MrdAppTranslationsActionsTypes';

export function editTranslationsRequestActionCreator(action) {
  return {
    type: EDIT_TRANSLATIONS_REQUEST,
    payload: action,
  };
}

export function editTranslationsSuccessActionCreator() {
  return {
    type: EDIT_TRANSLATIONS_SUCCESS,
  };
}

export function editTranslationsFailureActionCreator(error) {
  return {
    type: EDIT_TRANSLATIONS_FAILURE,
    payload: error,
    error: true,
  };
}
export function clearPreservedData() {
  return {
    type: CLEAR_PRESERVED_IMPC,
  };
}
